import { render, staticRenderFns } from "./BotAgentForm.vue?vue&type=template&id=252b7657"
import script from "./BotAgentForm.vue?vue&type=script&lang=ts"
export * from "./BotAgentForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports